import styled from 'styled-components'

const GuildRace = styled.div`
  width: 100%;

  .search-box {
    display: flex;
    /* justify-content: flex-end; */
    align-items: center;
    justify-content: end;
    gap: 20px;
    margin-bottom: 20px;
    margin-top: 60px;
  }

  .box-tabs-current-race {
    display: flex;
    margin-top: 16px;
    width: 1000px;
    justify-content: space-between;
  }

  .button-box {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 30px 0;

    span {
      text-transform: uppercase;
      font-size: 18px;
    }
  }
`

export const ButtonSyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 16px;
`

export default GuildRace
